import {ContentProvider} from "../../../../../domain/entities/content-provider/content-provider";
import {Content} from "../../../../presentation/views/content/helpers";
import {ContentProgressStatus} from "../../../../../domain/entities/content/content";
import {getContentProvider, getCurrentContent} from "./content_module";
import {ActionContext} from "vuex";
import {PlayerState} from "./player";

export class ProgressState {
  progressInterval: number | undefined = undefined;
}

const state = new ProgressState();
type ProgressActionContext = ActionContext<ProgressState, PlayerState>

const mutations = {
  SET_PROGRESS_INTERVAL(state: ProgressState, progressInterval: number | undefined) {
    state.progressInterval = progressInterval;
  },

  CLEAR_PROGRESS_INTERVAL(state: ProgressState) {
    clearInterval(state.progressInterval);
  },
};

const actions = {
  async startProgressRoutine(ctx: ProgressActionContext) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);

      if (content.status.progress === ContentProgressStatus.FINISHED) return;

      if (!content.minDuration && !content.status.finishedAt) {
        await provider.finishContent(content.id);
        await ctx.dispatch("content_module/loadAllContents", null, {root: true});
        return;
      }
      if (!content.minDuration) return;

      const interval = setInterval(async () => await saveProgress(ctx, provider, content), 15000);
      ctx.commit("SET_PROGRESS_INTERVAL", interval);
    } catch (e) {
      console.error("[startProgressRoutine] Error saveProgress", e);
      throw e;
    }
  },

  async stopProgressRoutine(ctx: ProgressActionContext) {
    try {
      ctx.commit("CLEAR_PROGRESS_INTERVAL");
    } catch (e) {
      console.error("[stopProgressRoutine] Error CLEAR_PROGRESS_INTERVAL", e);
      throw e;
    }
  },
};

/** TODO: REFACTOR -> SINGLE RESPONSIBILITY. */
/** Save the content progress based on the content's minimum duration.
 * Update the content progress on the content list.
 * Finish the content if user reach the min duration.
 * @see Content.minDuration */
const saveProgress = async (ctx: ProgressActionContext, provider: ContentProvider, content: Content): Promise<void> => {
  try {
    if (content.status.progress !== ContentProgressStatus.REACH_MIN) {
      const playbackRate: number = ctx.rootGetters["content_module/player/playbackRate"];
      content.status.progress = await provider.saveProgress(content.id, playbackRate);
    }

    if (content.status.progress === ContentProgressStatus.REACH_MIN) {
      await provider.finishContent(content.id);
      ctx.commit("CLEAR_PROGRESS_INTERVAL");
      await ctx.dispatch("content_module/loadAllContents", null, {root: true})
    } else {
      await ctx.dispatch("content_module/updateContentOnList", content, {root: true});
    }

  } catch (e) {
    console.error("[saveProgress] Error ", e);
    throw e;
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}